{
  "plugins": {
    "templateEngine": {
      "tqlNodes": "Узлы TQL",
      "ciTypes": "Типы КЕ",
      "blocks": "Блоки кода",
      "functions": "Функции",
      "templates": "Шаблоны"
    },
    "copy": {
      "copied": "Скопировано"
    }
  }
}